import React from "react";
import { AGREEMENT_TYPES } from "../../hooks/useDocuSignAgreements";
import DocuSignAgreementDialog from "./findMeATenant/DocuSignAgreementDialog";

const EquipmentLeaseDialog = ({
  open, onClose, onAgreed,
  uid, email, fullName,
  selectedPackage,
  orderId,
}) => {
  const prefillTabs = selectedPackage
    ? {
        textTabs: [
          { tabLabel: "package_name",   value: selectedPackage.name || "" },
          { tabLabel: "lock_brand",     value: selectedPackage.lockBrand || "" },
          { tabLabel: "entry_type",     value: selectedPackage.entryType || "" },
          { tabLabel: "monthly_rate",   value: `$${selectedPackage.monthlyRate?.toFixed(2)}/month` },
          { tabLabel: "term_months",    value: `${selectedPackage.termMonths} months` },
          { tabLabel: "total_contract", value: `$${(selectedPackage.monthlyRate * selectedPackage.termMonths).toFixed(2)}` },
          { tabLabel: "effective_date", value: new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }) },
          { tabLabel: "signer_name",    value: fullName || "" },
          { tabLabel: "signer_email",   value: email    || "" },
        ],
      }
    : null;

  const description = selectedPackage
    ? `Please review and sign the Equipment Lease Agreement for the ${selectedPackage.name} ` +
      `at $${selectedPackage.monthlyRate?.toFixed(2)}/month for ${selectedPackage.termMonths} months. ` +
      `Total contract value: $${(selectedPackage.monthlyRate * selectedPackage.termMonths).toFixed(2)}.`
    : "Please review and sign the Equipment Lease Agreement before your order is created.";

  return (
    <DocuSignAgreementDialog
      open={open}
      onClose={onClose}
      onAgreed={onAgreed}
      uid={uid}
      email={email}
      fullName={fullName}
      agreementType={AGREEMENT_TYPES.EQUIPMENT_LEASE}
      orderId={orderId}
      title="Equipment Lease & Services Agreement"
      description={description}
      prefillTabs={prefillTabs}
    />
  );
};

export default EquipmentLeaseDialog;